<template>
  <SkeletonComponent height="48px" />
</template>

<script setup lang="ts">
import {SkeletonComponent} from "@syncfusion/ej2-vue-notifications";
</script>

<style scoped>

</style>
